/**
 * Shared pause/stop signal for export modules.
 *
 * Distinct from a failure so the caller can report "paused" rather than
 * "export failed" — the checkpoints are intact either way (§7's resumability
 * non-negotiable), so this is an ordinary outcome, not an error condition.
 */
export class ExportAbortedError extends Error {
    constructor() {
        super("Export aborted by the user");
        this.name = "ExportAbortedError";
    }
}

export function throwIfAborted(signal: AbortSignal | undefined): void {
    if (signal?.aborted) {
        throw new ExportAbortedError();
    }
}
